/*
 * @Description: 下载文件
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-19 15:19:52
 */
import {
  threeLevelProjectPayListExportZip,
  projectPayPeopleDetailExportZip
} from '@/api/ajax';

const getAjax = projectStructureType => {
  // projectStructureType === 1: 四级(三级汇总\三级灵工asp-新未来-c), 其他都已三级结构处理
  let downloadAjax =
    projectStructureType === 1
      ? projectPayPeopleDetailExportZip
      : threeLevelProjectPayListExportZip;
  return downloadAjax;
};
/**
 * @description: 弹层并下载
 * @param {object} row 当前项目数据
 * @param {object} query 搜索条件
 * @param {string} selectedType 下载方式 all全部 selected批量
 * @param {array} selectedArr 批量选择集合
 * @return {*}
 */
const receiptDownload = function({ row, query, selectedType, selectedArr }) {
  let { id, taskDt, projectName, projectStructureType } = row;
  let { fullName, geTienterpriseName, supplieName, phone } = query;
  let ajax = getAjax(projectStructureType);

  this.$prompt('请输入文件名', '回单下载', {
    closeOnClickModal: false,
    confirmButtonText: '保存',
    showCancelButton: false,
    inputErrorMessage: '请填写4~100个字符（汉字、数字、英文、-、_）做为文件名',
    inputValue: taskDt + '_' + projectName,
    inputPattern: /^[A-Za-z0-9\u4E00-\u9FA5-_]{4,100}$/,
    // inputValidator(v) {
    //   return Boolean((v + '').length);
    // },
    async beforeClose(action, instance, done) {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';
        let data = {
          id,
          csoOrderId: id,
          fullName,
          geTienterpriseName,
          supplieName,
          phone,
          zipName: instance.inputValue,
          projectStructureType,
          payCsoOrderPeopleId: '',
          paySupplierOrderPeopleId: ''
        };
        if (selectedType === 'selected') {
          Object.assign(data, {
            payCsoOrderPeopleId: selectedArr
              .map(item => item.orderPeopleId)
              .join(','),
            paySupplierOrderPeopleId: selectedArr
              .map(item => item.orderId)
              .join(',')
          });
        }
        try {
          await ajax(data);
          done();
        } catch (e) {
          console.error(e);
        }
        instance.confirmButtonText = '保存';
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  })
    .then(async () => {
      this.$confirm('文件已经在下载中心内进行生成,如需下载请前往下载中心', '', {
        showCancelButton: false,
        showConfirmButton: false
      }).then(() => {});
    })
    .catch(() => {});
};
export default receiptDownload;
